import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Video } from 'lucide-react';
import { liveProgramsAPI } from '../utils/api';

const labels = { webinar: 'Webinars', mentorship: 'Mentorship Programs', workshop: 'Workshops', guidance: '1:1 Guidance' };
const money = (minor, currency = 'INR') => new Intl.NumberFormat('en-IN', { style: 'currency', currency, maximumFractionDigits: 2 }).format((minor || 0) / 100);

const LiveProgramsListingPage = ({ type }) => {
  const [programs, setPrograms] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    let active = true;
    liveProgramsAPI.getByType(type).then(({ data }) => {
      if (active) { setPrograms(data.data || []); setState('ready'); }
    }).catch(() => active && setState('error'));
    return () => { active = false; };
  }, [type]);

  return <div className="min-h-screen bg-black pt-24 pb-16"><div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <h1 className="text-4xl font-bold text-white">{labels[type]}</h1>
    <p className="mt-3 text-gray-400">Learn live with iStockly instructors.</p>
    {state === 'loading' && <p role="status" className="py-16 text-gray-300">Loading live programs…</p>}
    {state === 'error' && <p role="alert" className="mt-8 rounded border border-red-500 bg-red-950/40 p-4 text-red-200">Live programs could not be loaded. Please try again.</p>}
    {state === 'ready' && programs.length === 0 && <div className="py-20 text-center"><Video className="mx-auto h-14 w-14 text-gray-600"/><p className="mt-4 text-gray-400">No {labels[type].toLowerCase()} are scheduled.</p></div>}
    <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">{programs.map(program => {
      const session = program.sessions?.[0]; const amount = program.price?.sale_amount_minor ?? program.price?.list_amount_minor ?? 0;
      return <Link key={program.id} to={`/live/${program.type}/${program.slug}`} className="overflow-hidden rounded-xl border border-zinc-800 bg-zinc-900 transition hover:border-yellow-500">
        {program.thumbnail_url ? <img src={program.thumbnail_url} alt="" className="aspect-video w-full object-cover"/> : <div className="flex aspect-video items-center justify-center bg-zinc-800"><Video className="h-14 w-14 text-gray-600"/></div>}
        <div className="p-6"><span className="rounded-full bg-yellow-400/10 px-3 py-1 text-xs text-yellow-400">{program.mode}</span><h2 className="mt-3 text-xl font-semibold text-white">{program.title}</h2><p className="mt-2 line-clamp-2 text-sm text-gray-400">{program.short_description}</p>
          {session && <p className="mt-4 flex items-center gap-2 text-sm text-gray-300"><Calendar className="h-4 w-4"/>{new Date(session.starts_at).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</p>}
          <p className="mt-5 text-2xl font-bold text-yellow-400">{amount === 0 ? 'Free' : money(amount, program.price.currency)}</p>
        </div></Link>;
    })}</div>
  </div></div>;
};

export default LiveProgramsListingPage;
